import { Autorenew } from "@material-ui/icons";
import { Card, IconButton, ThemeProvider, Tooltip } from "@mui/material";
import Table from "components/table/Table";
import { ALL_OPTION, LIST_CALL_TYPE } from "constant";
import { useModalState } from "hooks/useModalState";
import { usePagination } from "hooks/usePagination";
import CallFlowChangeStatusModal from "pages/cloudPbx/call-flow/components/CallFlowChangeStatusModal";
import { useMemo, useState } from "react";
import {
  useGetCountListCallFlow,
  useGetListCallFlow,
} from "service/query/call-flow.query";
import muiTheme from "theme/muiTheme";

import CallFlowDetailModal from "./components/CallFlowDetailModal";
import CallFlowFilter from "./components/CallFlowFilter";
import CallFlowHistoryModal from "./components/CallFlowHistoryModal";

const CallFlow = () => {
  const {
    page,
    pageSize,
    limit,
    skip,
    handleChangePage,
    handleChangePageSize,
  } = usePagination();
  const [where, setWhere] = useState();
  const [currentItem, setCurrentItem] = useState(null);

  const updateModal = useModalState();
  const historyModal = useModalState();
  const changeStatusModal = useModalState();

  const { data: listCallFlow, isFetching } = useGetListCallFlow(
    {
      filter: {
        order: "createdAt DESC",
        limit,
        skip,
        where: {
          ...where,
          isHistory: false,
        },
      },
    },
    { placeholderData: (prev) => prev }
  );

  const { data: count } = useGetCountListCallFlow({
    where: {
      ...where,
      isHistory: false,
    },
  });

  const columns = useMemo(
    () => [
      {
        id: "callFlowId",
        name: "Mã call flow",
      },
      {
        id: "contactCenterInfo.name",
        name: "Bộ phận",
      },
      {
        id: "callType",
        name: "Loại cuộc gọi",
        render: (record) =>
          LIST_CALL_TYPE.find((item) => item.value === record.callType)?.label,
      },
      { id: "number", name: "Đầu số" },
      { id: "status", name: "Trạng thái", type: "status" },
      {
        id: "createdAt",
        name: "Thời gian tạo",
        type: "datetime",
      },
      {
        id: "updatedAt",
        name: "Thời gian cập nhật",
        type: "datetime",
      },
    ],
    []
  );

  const handleOpenModalCreate = () => {
    setCurrentItem(null);
    updateModal.openModal();
  };

  const handleOpenModalEdit = (record) => {
    setCurrentItem(record);
    updateModal.openModal();
  };

  const handleSearch = ({
    contactCenter,
    callFlowId,
    callType,
    number,
    status,
  }) => {
    setWhere({
      ...(contactCenter !== ALL_OPTION.value && { contactCenter }),
      ...(callFlowId && { callFlowId: { like: callFlowId } }),
      ...(callType !== ALL_OPTION.value && { callType }),
      ...(number !== ALL_OPTION.value && { number: { like: number } }),
      ...(status !== ALL_OPTION.value && { status }),
    });
    handleChangePage(1);
  };

  const handleOpenModalViewHistory = (record) => {
    setCurrentItem(record);
    historyModal.openModal();
  };

  const handleCloseViewHistoryModal = () => {
    setCurrentItem(null);
    historyModal.closeModal();
  };

  const handleCloseCallFlowDetailModal = () => {
    setCurrentItem(null);
    updateModal.closeModal();
  };

  const handleOpenModalChangeStatus = (record) => {
    changeStatusModal.openModal();
    setCurrentItem(record);
  };
  const handleCloseChangeStatusModal = () => {
    setCurrentItem(null);
    changeStatusModal.closeModal();
  };

  return (
    <div>
      <ThemeProvider theme={muiTheme}>
        <Card sx={{ p: 2 }}>
          <CallFlowFilter onSubmit={handleSearch} />
        </Card>
        <Card sx={{ mt: 2 }}>
          <Table
            columns={columns}
            data={listCallFlow}
            showHoverRow
            actionColumn={{
              onEdit: handleOpenModalEdit,
              onViewHistory: handleOpenModalViewHistory,
              colorButtonEdit: "primary",
              colorButtonViewHistory: "primary",
              customActions: (record) => (
                <Tooltip title="Cập nhật trạng thái">
                  <IconButton
                    onClick={() => handleOpenModalChangeStatus(record)}
                    color="primary">
                    <Autorenew />
                  </IconButton>
                </Tooltip>
              ),
            }}
            toolbar={{
              title: "Danh sách luồng cuộc gọi",
              onCreate: handleOpenModalCreate,
            }}
            pagination={{
              page,
              pageSize,
              totalItems: count,
              onPageChange: handleChangePage,
              onPageSizeChange: handleChangePageSize,
            }}
            loading={isFetching}
          />
        </Card>

        {updateModal.open && (
          <CallFlowDetailModal
            open={updateModal.open}
            onClose={handleCloseCallFlowDetailModal}
            currentItem={currentItem}
            mode={currentItem ? "edit" : "create"}
          />
        )}

        {historyModal.open && (
          <CallFlowHistoryModal
            open={historyModal.open}
            onClose={handleCloseViewHistoryModal}
            historyRecords={currentItem.historyRecords}
          />
        )}
        {changeStatusModal.open && (
          <CallFlowChangeStatusModal
            open={changeStatusModal.open}
            onClose={handleCloseChangeStatusModal}
            currentItem={currentItem}
          />
        )}
      </ThemeProvider>
    </div>
  );
};

export default CallFlow;
